import ImageElement from './image-element/image-element-container';
import ShapeElement from './shape-element';
import GroupElement from './group-element';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';

export {
    ShapeElement,
    ImageElement,
    GroupElement,
};

export function elementFromType(type: UIModelType) {
    switch (type) {
        case UIModelType.SHAPE:
            return ShapeElement;
        case UIModelType.IMAGE:
            return ImageElement;
        case UIModelType.GROUP:
            return GroupElement;
        default:
            return null;
    }
}

